<template>
  <div class="questionnaire-template-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <div class="template-config">
      <div class="template-config-mobile">
        <div class="template-config-mobile-top">{{formData.templateName || '模板名称'}}</div>
        <div class="template-config-mobile-center">
         <draggable :list="formData.questions">
          <div class="template-config-mobile-center-item" v-for="(item, index) in formData.questions" @click="changeCurrentSubjectIndex(index)" :class="{active:currentSubjectIndex===index}">
            <div class="del">
              <div class="template-config-mobile-center-item-name">{{index + 1 + '.' + item.questionName}}</div>
              <div @click.stop="del(index)">x</div>
            </div>
            <div class="template-config-mobile-center-item-info">
              <el-input disabled size="small" v-if="item.questionType === '1'" />
              <el-input disabled size="small" type="textarea" :rows="3" v-if="item.questionType === '2'" />
              <el-input-number disabled size="small" controls-position="right" v-if="item.questionType === '3'" style="width: 100%;"></el-input-number>
              <el-input disabled size="small" v-if="item.questionType === '4'" />
              <el-radio-group style="display: flex;justify-content: flex-start;flex-direction: column;align-items: flex-start;" v-if="item.questionType === '5'">
                <el-radio disabled v-for="(options, optionsIndex) in item.options" :key="optionsIndex" style="margin-bottom: 5px;">{{item.options[optionsIndex].optionDes}}</el-radio>
              </el-radio-group>
              <el-checkbox-group style="display: flex;justify-content: flex-start;flex-direction: column;" v-if="item.questionType === '6'">
                <el-checkbox disabled v-for="(options, optionsIndex) in item.options" :key="optionsIndex" style="margin-bottom: 5px" :label="item.options[optionsIndex].optionDes"></el-checkbox>
              </el-checkbox-group>
              <div class="enclosure-box" v-if="item.questionType === '7'">
                <i class="el-icon-plus"></i>
              </div>
            </div>
          </div>
         </draggable> 
        </div>
        <div class="template-config-mobile-bottom" @click="addSubjectItem">添加字段</div>
      </div>
      <form>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">模板名称：</span>
          </div>
          <el-input v-model="formData.templateName" size="small" style="width: 280px" />
        </div>

        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">题目名称：</span>
          </div>
          <el-input v-model="formData.questions[currentSubjectIndex].questionName" size="small" style="width: 280px" />
        </div>

        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">字段类型：</span>
          </div>
          <el-radio-group v-model="formData.questions[currentSubjectIndex].questionType" @change="questionTypeChange" size="small">
            <el-radio-button label="1">单行文本</el-radio-button>
            <el-radio-button label="2">多行文本</el-radio-button>
            <el-radio-button label="3">数字</el-radio-button>
            <el-radio-button label="4">金额</el-radio-button>
            <el-radio-button label="5">单选题</el-radio-button>
            <el-radio-button label="6">多选题</el-radio-button>
            <el-radio-button label="7">附件</el-radio-button>
          </el-radio-group>
        </div>

        <div class="form-line" v-if="formData.questions[currentSubjectIndex].questionType === '1'">
          <div class="textBox">
            <span class="line-text">单行文本：</span>
          </div>
          <el-input disabled size="small" style="width: 280px" />
        </div>

        <div class="form-line" v-if="formData.questions[currentSubjectIndex].questionType === '2'">
          <div class="textBox">
            <span class="line-text">多行文本：</span>
          </div>
          <el-input disabled size="small" type="textarea" :rows="3" style="width: 280px" />
        </div>

        <div class="form-line" v-if="formData.questions[currentSubjectIndex].questionType === '3'">
          <div class="textBox">
            <span class="line-text">数字：</span>
          </div>
          <el-input-number disabled size="small" controls-position="right" style="width: 280px"></el-input-number>
        </div>

        <div class="form-line" v-if="formData.questions[currentSubjectIndex].questionType === '4'">
          <div class="textBox">
            <span class="line-text">金额：</span>
          </div>
          <el-input disabled size="small" style="width: 280px" />
        </div>

        <div class="form-line" v-if="formData.questions[currentSubjectIndex].questionType === '5'">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">单选题：</span>
          </div>
          <div style="display: flex;justify-content: flex-start;flex-direction: column;align-items: flex-start;">
            <div v-for="(item, index) in formData.questions[currentSubjectIndex].options" :key="index" style="margin-bottom: 20px;display: flex;align-items: center;">
              <el-input size="small" style="width: 280px;margin-right: 10px;" v-model="formData.questions[currentSubjectIndex].options[index].optionDes" />
              <i class="el-icon-remove-outline" @click="cutOptionsItem(index)" v-if="index > 1"></i>
              <i class="el-icon-circle-plus" @click="addOptionsItem()" v-if="index > 0 && index === formData.questions[currentSubjectIndex].options.length - 1"></i>
            </div>
          </div>
        </div>

        <div class="form-line" v-if="formData.questions[currentSubjectIndex].questionType === '6'">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">多选题：</span>
          </div>
          <div style="display: flex;justify-content: flex-start;flex-direction: column;align-items: flex-start;">
            <div v-for="(item, index) in formData.questions[currentSubjectIndex].options" :key="index" style="margin-bottom: 20px;display: flex;align-items: center;">
              <el-input size="small" style="width: 280px;margin-right: 10px;" v-model="formData.questions[currentSubjectIndex].options[index].optionDes" />
              <i class="el-icon-remove-outline" @click="cutOptionsItem(index)" v-if="index > 1"></i>
              <i class="el-icon-circle-plus" @click="addOptionsItem()" v-if="index > 0 && index === formData.questions[currentSubjectIndex].options.length - 1"></i>
            </div>
          </div>
        </div>

        <div class="form-line" v-if="formData.questions[currentSubjectIndex].questionType === '7'">
          <div class="textBox">
            <span class="line-text">附件：</span>
          </div>
          <div class="enclosure-box">
            <i class="el-icon-plus"></i>
          </div>
        </div>

        <div class="form-line">
          <div class="textBox">
            <span class="line-text">其他：</span>
          </div>
          <el-checkbox v-model="formData.questions[currentSubjectIndex].required" size="small">必填</el-checkbox>
        </div>

        <div class="form-btn-box">
          <button-confirm value="保存" @confirm="confirm" />
          <button-cancel @cancel="cancel" />
        </div>
      </form>
    </div>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import draggable from "vuedraggable";
import { bus } from "../../../utils/bus";
import { api } from "../../api/Questionnaire";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb,
    draggable
  },
  name: "questionnaire-template-modify",
  data() {
    return {
      breadcrumb: [
        {
          value: "数据采集",
          name: "questionnaire-template-manage"
        },
        {
          value: "模板管理"
        }
      ],
      mainTitle: "修改模板",
      subheading: "",

      currentSubjectIndex: 0,

      responsiblePersonList: [],
      optionsNumberList: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ],
      formData: {
        templateName: "",
        questions: [
          {
            questionName: "",
            questionNumber: "",
            questionType: "1",
            options: [],
            required: ""
          }
        ]
      }
    };
  },
  created() {
    this.getTemplateByCode();
  },
  methods: {
    // 查询
    getTemplateByCode() {
      this.$axios
        .get(`${api.getTemplateByCode}/${this.$route.params.id}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let res1 = res.data.data;
            res1.questions.map(question => {
              delete question.option;
            });
            this.formData = res1;
            console.log(this.formData);
          }
        })
        .catch(errorHandler("查询失败"));
    },

    // 修改题目
    changeCurrentSubjectIndex(index) {
      this.currentSubjectIndex = index;
      console.log(this.currentSubjectIndex);
    },

    // 添加题目
    addSubjectItem() {
      let obj = {
        questionName: "",
        // questionNumber: "",
        questionNumber: this.formData.questions.length + 1,
        questionType: "1",
        options: [],
        required: ""
      };
      this.formData.questions.push(obj);
    },

    // 删除选项
    cutOptionsItem(index) {
      this.formData.questions[this.currentSubjectIndex].options.splice(
        index,
        1
      );
    },

    // 添加选项
    addOptionsItem() {
      console.log(this.formData.questions[this.currentSubjectIndex].options);
      let flag = false;
      let obj = {
        optionName: this.optionsNumberList[
          this.formData.questions[this.currentSubjectIndex].options.length
        ],
        optionDes: ""
      };
      this.formData.questions[this.currentSubjectIndex].options.map(v => {
        if (v.optionDes == "") {
          flag = false;
          return nError("请先输入选项");
        } else {
          flag = true;
        }
      });
      if (flag == true) {
        this.formData.questions[this.currentSubjectIndex].options.push(obj);
      }
    },

    questionTypeChange(val) {
      if (val === "5" || val === "6") {
        this.formData.questions[this.currentSubjectIndex].options = [
          { optionName: "A", optionDes: "" },
          { optionName: "B", optionDes: "" }
        ];
      } else {
        this.formData.questions[this.currentSubjectIndex].options = [];
      }
    },

    toManagementPage() {
      this.$router.push({
        name: "questionnaire-template-manage"
      });
    },

    // 保存
    confirm() {
      this.formData.questions.map((v, i) => {
        v.questionNumber = i + 1;
      });

      if (!this.formData.templateName) {
        nError("请输入模板名称");
        return false;
      }

      let isAllQuestionName = true;
      this.formData.questions.map(v => {
        if (!v.questionName) {
          isAllQuestionName = false;
        }
      });
      if (!isAllQuestionName) {
        nError("请输入题目名称");
        return false;
      }

      let isAllOptionDes = true;
      this.formData.questions.map(v => {
        if (v.questionType == "5" || v.questionType == "6") {
          v.options.map(v => {
            console.log(v);
            if (!v.optionDes) {
              isAllOptionDes = false;
            }
          });
        }
      });
      if (!isAllOptionDes) {
        nError("请输入题目选项");
        return false;
      }

      this.$axios
        .post(api.updateTemplate, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("保存成功");
            this.toManagementPage();
          }
        })
        .catch(errorHandler("保存失败"));
    },

    cancel() {
      this.toManagementPage();
    },
    del(index) {
      if (this.formData.questions.length !== 1) {
        this.formData.questions.splice(index, 1);
        this.currentSubjectIndex = 0;
      } else {
        nError("至少存在一个模板问题");
      }
      console.log(this.formData.questions);
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
  vertical-align: sub;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.form-line > div {
  margin-right: 20px;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 190px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 600px;
  padding: 0 110px;
  margin: 40px 0 0 0;
  display: flex;
  justify-content: space-between;
}
.newly2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  border: 1px dashed #d7d7d7;
  margin-right: 20px;
  position: relative;
}
.newly2 span {
  display: block;
  width: 100%;
  color: #999999;
  margin: 0;
  padding: 0;
  text-align: center;
}
.newly2 span:first-child {
  font-size: 36px;
  line-height: 120px;
  position: absolute;
  top: 15px;
}
.newly2 span:last-child {
  font-size: 14px;
  line-height: 50px;
  position: absolute;
  bottom: 0;
}
.upload2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  background-size: 100% 100%;
  position: relative;
}

.upload2 img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.upload2 b {
  display: inline-block;
  width: 100%;
  line-height: 21px;
  color: white;
  background-color: #989796;
  text-align: center;
  position: absolute;
  bottom: 0;
  opacity: 0.7;
}
.del {
  display: flex;
  justify-content: space-between;
}
.active {
  border: 4px solid #1362ff;
}
</style>

<style lang="less">
.el-switch {
  height: 30px;
}

.questionnaire-template-add {
  .template-config {
    display: flex;
    justify-content: flex-start;
    // align-items: flex-start;
    margin: 25px 0;
    .template-config-mobile {
      width: 313px;
      height: 556px;
      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
      border-radius: 7px;
      margin: 0 60px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      .template-config-mobile-top {
        width: 313px;
        height: 47px;
        line-height: 47px;
        padding: 0 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        color: #ffffff;
        background: #104079;
        border-radius: 7px 7px 0px 0px;
      }
      .template-config-mobile-center {
        padding: 10px 0;
        flex: 1;
        background: #104079;
        overflow-y: auto;
        .template-config-mobile-center-item {
          width: 288px;
          background: #ffffff;
          border-radius: 7px;
          padding: 15px 13px;
          margin: 0 auto 20px;
          cursor: pointer;
          .template-config-mobile-center-item-name {
            text-align: left;
            font-size: 12px;
            line-height: 20px;
            color: #333333;
            word-wrap: break-word;
          }
          .template-config-mobile-center-item-info {
            margin-top: 10px;
            word-wrap: break-word;
            .el-checkbox {
              height: auto;
              display: flex;
              align-items: baseline;
              line-height: 18px;
            }
            .el-checkbox__label {
              width: 260px;
              height: auto;
              line-height: 18px;
              text-align: left;
              display: inline-block;
              word-wrap: break-word;
              word-break: break-all;
              white-space: pre-wrap !important;
            }
          }
        }
      }
      .template-config-mobile-bottom {
        width: 313px;
        height: 47px;
        line-height: 47px;
        font-size: 14px;
        color: #1362ff;
        background: #ffffff;
        border-radius: 0px 0px 7px 7px;
        cursor: pointer;
      }
    }
    form {
      flex: 1;
    }
  }
  .el-icon-remove-outline,
  .el-icon-circle-plus {
    font-size: 24px;
    cursor: pointer;
  }
  .el-icon-remove-outline {
    color: #707070;
  }
  .el-icon-circle-plus {
    color: #1362ff;
    margin-left: 5px;
  }
  .enclosure-box {
    width: 60px;
    height: 60px;
    line-height: 60px;
    border: 1px dashed #cfd5e2;
    border-radius: 3px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-icon-plus {
      color: #cfd5e2;
      font-size: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Questionnaire/TemplateManage/TemplateManageModify.vue